import React, { useRef, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "./taskList.scss"
import {
  Button,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import TaskApi from "Api/TaskApi"

const Tasklist = () => {
  document.title = "Task"
  const uploadBtnRef = useRef()
  const navigate = useNavigate()

  const [excelLoader, setExcelLoader] = useState(false)
  const [page, setPage] = useState(1)
  const [taskDetails, setTaskDetails] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)

  const limit = 10
  const totalPages = Math.ceil(totalRecords / limit)
  const accessToken = localStorage.getItem("accessToken")

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Task", link: "#" },
    { label: "Task List", link: "#" },
  ]

  const handleUploadButtonClick = () => {
    uploadBtnRef.current.click()
  }

  const handleFileChange = event => {
    setExcelLoader(true)
    setTimeout(() => {
      setExcelLoader(false)
    }, 1000)
  }

  const handleAssignTask = () => {
    navigate("/assignTask")
  }

  const getAllTasks = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit,
        page,
      },
    }

    TaskApi.getAllTask(config)
      .then(response => {
        if (response.data.status) {
          setLoading(false)
          setTaskDetails(response.data.task)
          setTotalRecords(response.data.totalRecords)
        }
      })
      .catch(error => {
      })
  }

  useEffect(() => {
    getAllTasks()
  }, [accessToken, page])

  return (
    <>
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Task Management"
            />

            <div className="d-flex align-items-center gap-3">
              <input
                type="file"
                ref={uploadBtnRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleAssignTask}
              >
                Assign Task
              </Button>
            </div>
          </div>

          <div className="task-data-table table-responsive mt-4 mb-3">
            {loading ? (
              <DataTableLoader cols={10} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Task Name</th>
                    <th>Assign To</th>
                    <th>Start Date</th>
                    <th>Due Date</th>
                    <th>Target</th>
                    <th>Status</th>
                    <th>Edit</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {taskDetails?.map((task, index) => {
                    const taskName = task?.taskName || "N/A"
                    const assignTo = task?.assignTo?.userName || "Unassigned"
                    const startDate = task?.startDate || "Not Set"
                    const dueDate = task?.dueDate || "Not Set"
                    const target = task?.target || "No Target"
                    const status =
                      task?.status?.split(" ").join("-").toLowerCase() ||
                      "unknown"
                    const statusDisplay =
                      status === "approve"
                        ? "Approved"
                        : status === "in-progress"
                          ? "In Progress"
                          : status === "completed"
                            ? "Completed"
                            : status === "not-started"
                              ? "Not Started"
                              : "In Review"

                    return (
                      <tr key={task._id} className="task-table-row">
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>{taskName}</td>
                        <td>{assignTo}</td>
                        <td>{startDate}</td>
                        <td>{dueDate}</td>
                        <td>{target}</td>
                        <td>
                          <span className={`status ${status}`}>
                            {statusDisplay}
                          </span>
                        </td>
                        <td>
                          <span
                            className="edit-task"
                            onClick={() => {
                              navigate(`/editTask/${task._id}`, {
                                state: task,
                              })
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                        <td>
                        <span
                          className="view-task"
                            onClick={() => {
                              navigate(`/viewTask/${task._id}`, {
                                state: task,
                              })
                            }}
                        >
                          <i className="ion ion ion-md-eye" />
                        </span>
                      </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            )}
          </div>

          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(totalPages)].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Tasklist
